import { render, staticRenderFns } from "./daxq.vue?vue&type=template&id=1747e55b&scoped=true&"
import script from "./daxq.vue?vue&type=script&lang=js&"
export * from "./daxq.vue?vue&type=script&lang=js&"
import style0 from "./daxq.vue?vue&type=style&index=0&id=1747e55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747e55b",
  null
  
)

export default component.exports